import AES from 'crypto-js/aes';
import EncUTF8 from 'crypto-js/enc-utf8';
import Cookie from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import AbstractStorage from 'Utils/storage/AbstractStorage';
const ENCRYPTION_KEY = Cookie.get('RIREKISHO_DK');
if (!ENCRYPTION_KEY) {
    datadogRum.addError(new Error('No encryption key found!'));
}
export default class EncryptedStorage extends AbstractStorage {
    static _instance;
    _isAvailable;
    constructor() {
        super();
    }
    static instance() {
        return this._instance || (this._instance = new EncryptedStorage());
    }
    encodeValues(v) {
        const jsonStr = JSON.stringify(v);
        return AES.encrypt(jsonStr, ENCRYPTION_KEY).toString();
    }
    decodeValues(encodedValue) {
        if (encodedValue === null) {
            return null;
        }
        try {
            const jsonStr = AES.decrypt(encodedValue, ENCRYPTION_KEY).toString(EncUTF8);
            return JSON.parse(jsonStr);
        }
        catch (e) {
            datadogRum.addError(e);
            return null;
        }
    }
    async isAvailable() {
        if (typeof this._isAvailable !== 'undefined') {
            return this._isAvailable;
        }
        try {
            // test if localStorage is available
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            this._isAvailable = true;
        }
        catch (e) {
            datadogRum.addError(e);
            this._isAvailable = false;
        }
        return this._isAvailable;
    }
    async getItem(key) {
        const encodedValue = localStorage.getItem(key);
        return this.decodeValues(encodedValue);
    }
    async setItem(key, rawValue) {
        try {
            localStorage.setItem(key, this.encodeValues(rawValue));
        }
        catch (e) {
            datadogRum.addError(e);
            throw e;
        }
    }
    async removeItem(key) {
        localStorage.removeItem(key);
    }
    hasKey(key) {
        return localStorage.getItem(key) !== null;
    }
}
